import { render } from "./IconRoad.vue.js?vue&type=template&id=00c3025b!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconRoad.vue?vue&type=template&id=00c3025b"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__